import "./MainLayout.scss";

export function MainLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="main-layout">
      <div className="main-layout-content">
        <main>{children}</main>
      </div>
    </div>
  );
}
